import { render, staticRenderFns } from "./JobCreateDetails.vue?vue&type=template&id=55abf5ea&"
import script from "./JobCreateDetails.vue?vue&type=script&lang=js&"
export * from "./JobCreateDetails.vue?vue&type=script&lang=js&"
import style0 from "./JobCreateDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports